import React, { Fragment } from "react";

export default function CustomDescriptionInput({
  name,
  labelText,
  register,
  error,
}) {
  return (
    <Fragment>
      <label htmlFor={name} className="font-poppins text-gray-500 text-xs lg:text-sm">
        {labelText}
      </label>
      <p className="relative">
        <textarea
          type="text"
          name={name}
          placeholder="Enter"
          className={`w-full p-2 lg:p-3 h-28 border-bw rounded-md text-xs lg:text-sm font-figtree placeholder:text-xs lg:placeholder:text-sm placeholder:font-figtree placeholder:text-black focus-input ${
            error ? "border-red-500" : "border-lg4"
          }`}
          {...register}
        />
      </p>
      <p
        className={`text-red-500 font-figtree text-xs h-4 ${
          error ? "visible" : "invisible"
        }`}
      >
        {error?.message}
      </p>
    </Fragment>
  );
}
